import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import SectionWrapper from "@/components/Base/SectionWrapper.vue";
import HzbaForm from "@/components/hzba/Base/HzbaForm.vue";
import HzbaDeleteDuplicateItem from "@/components/hzba/Base/Input/HzbaDeleteDuplicateItem.vue";
import RecursiveForm from "@/components/hzba/RecursiveForm.vue";
import SurveyMapFragenblockButtons from '@/components/v2/Map/SurveyMapFragenblockButtons.vue';
import {
    getNestedBreadcrumbTitles,
    useIdentifierFragenblockFinder
} from "@/composables/Bestandsaufnahme/useIdentifierFinder";
import { useStore } from "@/composables/useTypedStore";
import useUser from "@/composables/useUser";
import { Fragenblock } from "@/models/ba/Fragenblock";
import { IonContent } from "@ionic/vue";
import { computed } from "vue";
import BestandsaufnahmeModel from "@/models/ba/models/bestandsaufnahme.model";
import _ from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'FragenblockContent',
  props: {
    fragenblockBase: {},
    modalDepth: {},
    surveyMapModal: { type: Boolean }
  },
  emits: ["delete", "duplicate"],
  setup(__props: any) {

const props = __props;






const { user } = useUser();
const store = useStore();

const currentBa = computed(() => {
    return store.state.currentHzba.currentBa;
});

const fragenblock = computed<Fragenblock | undefined>(() => {
    return currentBa.value && useIdentifierFragenblockFinder(currentBa.value, props.fragenblockBase.path, undefined);
});

const isAllowedToEdit = computed(() => {
    // flag only matters atm for surveyMapModal
    return !props.surveyMapModal || (user.value?.id && fragenblock.value?.config?.userId === user.value.id);
});

const getNestedBreadcrumbTitle = (path: string) => {
    return path && currentBa.value && getNestedBreadcrumbTitles(currentBa.value, path);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      (!_ctx.surveyMapModal && fragenblock.value?.path)
        ? (_openBlock(), _createBlock(SectionWrapper, {
            key: 0,
            class: "mt-4 mx-6 text-xs",
            style: {"color":"#7f7f7f"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getNestedBreadcrumbTitle(fragenblock.value.path)), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(SectionWrapper, null, {
        default: _withCtx(() => [
          (!_ctx.surveyMapModal && fragenblock.value)
            ? (_openBlock(), _createBlock(RecursiveForm, {
                key: 0,
                "parent-fragenblock": fragenblock.value,
                "modal-depth": _ctx.modalDepth
              }, null, 8, ["parent-fragenblock", "modal-depth"]))
            : _createCommentVNode("", true),
          (_ctx.surveyMapModal)
            ? (_openBlock(), _createBlock(HzbaForm, {
                key: 1,
                "read-only": !isAllowedToEdit.value,
                "form-frages": fragenblock.value?.frages ?? []
              }, null, 8, ["read-only", "form-frages"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_ctx.surveyMapModal && isAllowedToEdit.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(SurveyMapFragenblockButtons, {
                    onDelete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
                  })
                ]))
              : (!_ctx.surveyMapModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (fragenblock.value && fragenblock.value.blockTyp && fragenblock.value.blockTyp.toLowerCase() === 'mehrfach')
                      ? (_openBlock(), _createBlock(HzbaDeleteDuplicateItem, {
                          key: 0,
                          fragenblock: fragenblock.value,
                          onDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete'))),
                          onDuplicate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('duplicate')))
                        }, null, 8, ["fragenblock"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})